'use client';

import { captureException } from '@sentry/nextjs';
import { Metadata } from 'next';
import { FC, useEffect } from 'react';

import { seoDefaultError } from '@/constants/constants';
import { WholePageMessage } from '@/general/sections/WholePageMessage/WholePageMessage';
import { ErrorPageProps } from '@/types/appRouter.types';

export const metadata: Metadata = {
  title: seoDefaultError.title,
  description: seoDefaultError.description,
};

const reloadPage = () => {
  if (globalThis.window !== undefined) {
    window.location.reload();
  }
};

const PageError: FC<ErrorPageProps> = ({ error }) => {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
    captureException(error);
  }, [error]);

  return (
    <WholePageMessage
      buttonLabel="Try again"
      buttonOnClick={reloadPage}
      title="Oops, looks like something went wrong"
      iconSrc="/images/components/BadgeIllustration/carma-touch.svg"
      fullHeight
    />
  );
};

export default PageError;
